import { render, staticRenderFns } from "./UserdataExternalTransmissionPage.vue?vue&type=template&id=b023e508&scoped=true"
import script from "./UserdataExternalTransmissionPage.vue?vue&type=script&lang=js"
export * from "./UserdataExternalTransmissionPage.vue?vue&type=script&lang=js"
import style0 from "./UserdataExternalTransmissionPage.vue?vue&type=style&index=0&id=b023e508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b023e508",
  null
  
)

export default component.exports